import React, { useEffect } from 'react'
import "../styles/requestAccess.css"
import AccessRequestForm from '../containers/AccesssRequestForm/AccessRequestForm';
import { Modal, notification } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAvailableRoles, fetchSuccessFactorData, fetchSuccessFactorUserRequest, sendNewAccessRequest, setSuccessFactorUserData } from '../store/reducers/successFactorUserSlice';
import { fetchUserData } from '../store/reducers/userSlice';
import { getUserAccessData, setUserAccessData } from '../utilities/sessionHelper';
import LoadingModal from '../components/LoadingModal/loadingModal';
import { getLandingPage, getUserRole, handleLogout, rejectedApiMessage } from '../utilities/CommonHelper';
import { useHistory } from 'react-router-dom';
import LoadingComp from '../utilities/LoadingComp';

const RequestAccess : React.FC<{type:string}>=({type})=> {
  const dispatch = useDispatch();
  const userSFData= useSelector((state: any) => state.successFactorUser);
  const userData= useSelector((state: any) => state.user);
  const [successFactorData,setSuccessFactorData]=React.useState<any>({});
  const [rolesAvailable,setRolesAvailable]=React.useState<any>([]);
  const [accessData,setAccessData]=React.useState<any>(getUserAccessData());
  const history = useHistory();

  const handleSubmit=(data:any)=>{
    dispatch(fetchSuccessFactorUserRequest());
    dispatch(sendNewAccessRequest(data)).then((response:any) => {
      if(response.type==='user/sendNewAccessRequest/fulfilled'){
        notification.success({
          message: 'Success',
          description: 'Request submitted successfully',
        });
        dispatch(fetchUserData()).then((res:any) => {

          if(res.type==='user/checkAccessToMyOrder/fulfilled'){
            setUserAccessData(res.payload.data);
            setAccessData(res.payload.data);
          }
          else{
            
            rejectedApiMessage(res.payload);
          }
        });
      }
      else{
        rejectedApiMessage(response.payload);
      }
      console.log('response', response);
    });
  }
  const getpendingRequestData = () => {
    let tempData=accessData.requestDTO;
    if(tempData && accessData.empAccessReqRaised){
      let values:any={
        "type": tempData.type,
        "name": tempData.employeeName,
        "email": tempData.employeeEmail,
        "id": tempData.employeeId,
        "businessUnit": tempData.businessUnit,
        "department": tempData.department,
        "reportingManagerName": tempData.reportingManagerName,
        "reportingManagerEmail": tempData.reportingManagerEmail,
        "role": tempData.role,
        "accessReason": tempData.accessReason,
      }
      return values;
    }
    return {}; 
   
  }
  useEffect(() => { 
    if(accessData?.empAccessReqRaised){
    dispatch(fetchUserData()).then((res:any) => {
      if(res.type==='user/checkAccessToMyOrder/fulfilled'){
        let _userData= res.payload.data;
        if(type==='new' && !_userData.empAccessReqRaised && _userData.employeeOrderAccess && !_userData.requestDTO && Object.keys(_userData.roleAccessMap).length>0){
          setUserAccessData(_userData)
          window.location.pathname="/";
          // return(<Redirect to='/' />)
          // history.push('/');
        }
        // else if(type==='edit' && !_userData.employeeOrderAccess  && Object.keys(_userData.roleAccessMap).length===0){

        //   handleLogout();
        // }
        else{
          setUserAccessData(_userData);
          setAccessData(_userData);
        }
        // setUserAccessData(res.payload.data);
        // setAccessData(res.payload.data);
      }
      else{
        
        rejectedApiMessage(res.payload);
      }
    });
  }
  },[]);

  useEffect(() => {
    if(!accessData?.empAccessReqRaised){
       
      dispatch(fetchSuccessFactorData()).then((response:any) => {

        if(response.type=='user/fetchSuccessFactorUserData/fulfilled'){

            dispatch(fetchAvailableRoles()).then((res:any) => {

              if(res.type!=='user/fetchavailableRoles/fulfilled'){
                rejectedApiMessage(res.payload);
              }
            });
        }
        else{
         rejectedApiMessage(response.payload);
        }
      })
    }

  },[])
  
  useEffect(() => {
    console.log("userSFData",userSFData);
    if(!userSFData.loading && userSFData.data){
      setSuccessFactorData(userSFData.data?userSFData.data:{});
      
    }
    // setSuccessFactorData(userSFData.data?userSFData.data:{});
    // setRolesAvailable(userSFData.availableRoles!=null && userSFData.availableRoles!=undefined?userSFData.availableRoles:[]);
    },[userSFData.data])
    useEffect(() => {
      if(!userSFData.loading && userSFData.availableRoles!=null && userSFData.availableRoles!=undefined){
        setRolesAvailable(userSFData.availableRoles);
      }
    },[userSFData.availableRoles])

  // useEffect(() => {

  //   if(userData.data){
  //     debugger;
  //     if(type==='new' && !userData.data.data.empAccessReqRaised && userData.data.data.employeeOrderAccess && !userData.data.data.requestDTO && Object.keys(userData.data.data.roleAccessMap).length>0){
  //       setUserAccessData(userData.data.data);
  //       history.push('/');
  //     }
  //     else if(type==='edit' && !userData.data.data.employeeOrderAccess  && Object.keys(userData.data.data.roleAccessMap).length===0){
  //       handleLogout();
  //     }
  //     else{
  //       setUserAccessData(userData.data.data);
  //       setAccessData(userData.data.data);
  //     }
  //   // setAccessData(userData.data);
  //   }
  // },[userData.data])

  return (
    <div 
    // className={type==="new"? "request-access-page-without-slider":"request-access-page-with-slider"}
    >
      <h2 className='page-heading'>
         {type==='new'? 'Create Access Request':type==='edit'?'Edit Access Request':""}
        </h2>
        {userSFData.loading && <div className='access-request-status'><p>Loading...</p></div>}
        {accessData?.empAccessReqRaised  && <div className='access-request-status'><p>Your access request is pending with {accessData?.requestDTO?.approvalRejects?.length==0 && accessData?.requestDTO?.type!=="REVOKE" ?"Reporting Manager":"Admin"}</p></div>}
        <AccessRequestForm type={type} onCancel={()=>{}} onSubmit={handleSubmit} editable={accessData?.empAccessReqRaised} data={accessData?.empAccessReqRaised?getpendingRequestData():successFactorData} roles={rolesAvailable} />
        {/* <Modal
          open={userSFData.loading}
          footer={null}
        //   centered
        closeIcon={false}
        
          styles={{
            content: {
                width: '1000px',
                height: '604px',
                top: '-50%',
                left: '-50%',
                borderRadius: '0',
                zIndex: '9999',
            }
          }
          }
        >
           <LoadingComp/>
        </Modal> */}
      </div>
  )
}
export default RequestAccess;